export enum DefaultPartnerEndpointGroup {
  Id = 1,
  Name = 'Default'
}



// WEBPACK FOOTER //
// ./src/constants/PartnerEndpointGroups.ts